import { SidebarMenuItem } from "../../../../_metronic/layout/components/sidebar/sidebar-menu/SidebarMenuItem";
import { SidebarMenuItemWithSub } from "../../../../_metronic/layout/components/sidebar/sidebar-menu/SidebarMenuItemWithSub";

import { useAuth } from "../../auth";
import { useAppView } from "../../core/app/AppViewContext";

const UserSidebarMenu = () => {

  const {currentUser, hasRole} = useAuth()
  const { cntApplications, cntDLMSiteInspectApplications, cntDLMDOCApplications, cntDLMLabelApplications } = useAppView();

  if (! currentUser) {
    return null;
  }

  return(
  <>
    { (currentUser.role !== 'System Admin') &&
    <SidebarMenuItem
      to='/setsco/application-management/applications'
      title="COC Applications"
      showCount={cntApplications}
      fontIcon='bi-card-checklist'
      icon='/media/icons/duotune/general/gen028.svg'
    />
    }

    { hasRole(['CAMS Admin','CAMS Program Manager','CAMS Inspector','CAMS Second Reviewer']) &&
    <SidebarMenuItem
      to='/setsco/certificate-management/certificates'
      title="Certificates"
      fontIcon='bi-archive'
      icon='/media/icons/duotune/coding/cod002.svg'
    />
    }

    { ((currentUser.role !== 'System Admin') && (hasRole(['System Admin','DLM Admin','DLM Program Manager','DLM Inspector']))) &&
    <>
    <SidebarMenuItemWithSub
      to="/setsco/doclabel-management/siteinspection"
      title='Site Inspections'
      icon='/media/icons/duotune/general/gen068.svg'
    >
      <SidebarMenuItem
        to='/setsco/doclabel-management/siteinspection-applications-list'
        title="Applications"
        showCount={cntDLMSiteInspectApplications}
        fontIcon='bi-card-checklist'
        icon='/media/icons/duotune/general/gen028.svg'
      />
      <SidebarMenuItem
        to='/setsco/doclabel-management/siteinspections-list'
        title="Inspections List"
        fontIcon='bi-card-checklist'
        icon='/media/icons/duotune/abstract/abs015.svg'
      />
    </SidebarMenuItemWithSub>
    <SidebarMenuItemWithSub
      to="/setsco/doclabel-management/docs"
      title='DOCs'
      icon='/media/icons/duotune/general/gen048.svg'
    >
      <SidebarMenuItem
        to='/setsco/doclabel-management/doc-applications-list'
        title="Applications"
        showCount={cntDLMDOCApplications}
        fontIcon='bi-card-checklist'
        icon='/media/icons/duotune/general/gen028.svg'
      />
      <SidebarMenuItem
        to='/setsco/doclabel-management/doc-list'
        title="DOC List"
        fontIcon='bi-card-checklist'
        icon='/media/icons/duotune/abstract/abs015.svg'
      />
      <SidebarMenuItem
        to="/setsco/file-uploader"
        title="Upload Files"
        icon='/media/icons/duotune/files/fil022.svg'
        fontIcon='bi-file'
      />
    </SidebarMenuItemWithSub>
    <SidebarMenuItemWithSub
      to="/setsco/doclabel-management/labels"
      title='Labels'
      icon='/media/icons/duotune/general/gen056.svg'
    >
      <SidebarMenuItem
        to='/setsco/doclabel-management/label-applications-list'
        title="Applications"
        showCount={cntDLMLabelApplications}
        fontIcon='bi-card-checklist'
        icon='/media/icons/duotune/general/gen028.svg'
      />
      <SidebarMenuItem
        to='/setsco/doclabel-management/label-site-applications-list'
        title="Site Applications"
        fontIcon='bi-card-checklist'
        icon='/media/icons/duotune/general/gen028.svg'
      />
      <SidebarMenuItem
        to='/setsco/doclabel-management/roi-list'
        title="ROI List "
        fontIcon='bi-card-checklist'
        icon='/media/icons/duotune/abstract/abs015.svg'
      />
      <SidebarMenuItem
        to='/setsco/doclabel-management/labels-list'
        title="Labels"
        fontIcon='bi-card-checklist'
        icon='/media/icons/duotune/general/gen021.svg'
      />
      <SidebarMenuItem
        to="/setsco/file-uploader"
        title="Upload Files"
        icon='/media/icons/duotune/files/fil022.svg'
        fontIcon='bi-file'
      />
    </SidebarMenuItemWithSub>

    </>
    }

    { ((currentUser.role !== 'System Admin') && ((! hasRole(['System Admin','DLM Admin','DLM Program Manager','DLM Inspector'])) && hasRole(['CAMS Quotation Admin']))) &&
    <>
    <SidebarMenuItemWithSub
      to="/setsco/doclabel-management/siteinspection"
      title='Site Inspections'
      icon='/media/icons/duotune/general/gen068.svg'
    >
      <SidebarMenuItem
        to='/setsco/doclabel-management/siteinspection-applications-list'
        title="Applications"
        showCount={cntDLMSiteInspectApplications}
        fontIcon='bi-card-checklist'
        icon='/media/icons/duotune/general/gen028.svg'
      />
    </SidebarMenuItemWithSub>
    </>
    }

    { (hasRole(['CAMS Admin','Super Admin'])) &&
    <>
    <SidebarMenuItemWithSub
      to="/setsco/reports"
      title='Reports'
      icon='/media/icons/duotune/general/gen032.svg'
    >
      { (hasRole('CAMS Admin')) &&
      <>
      <SidebarMenuItem
        to='/setsco/reports/phase-statistics'
        title='Phase Statistics'
        hasBullet={true}
      />
      <SidebarMenuItem
        to='/setsco/reports/application-statistics'
        title='Application Statistics'
        hasBullet={true}
      />
      <SidebarMenuItem
        to='/setsco/reports/user-statistics'
        title='User Statistics'
        hasBullet={true}
      />
      <SidebarMenuItem
        to='/setsco/reports/user-phase-statistics'
        title='User Phase Statistics'
        hasBullet={true}
      />
      <SidebarMenuItem
        to='/setsco/reports/billings'
        title='Billings'
        hasBullet={true}
      />
      </>
      } 
      { (hasRole('Super Admin')) &&
      <>
      <SidebarMenuItem
        to='/setsco/reports/summary-statistics'
        title='Summary Statistics'
        hasBullet={true}
      />
      </>
      }      
    </SidebarMenuItemWithSub>
    </>
    }

    


    { (hasRole(['CAMS Admin','System Admin','CAMS Program Manager','DLM Admin','User Admin','Super Admin'])) &&
    <SidebarMenuItemWithSub
      to="/setsco/doclabel-management/docs"
      title='Settings'
      icon='/media/icons/duotune/general/gen062.svg'
    >

      { (hasRole(['CAMS Admin','System Admin'])) &&
      <SidebarMenuItem
        to='/setsco/clientmanager-management/clientmanagers'
        title="Client Managers"
        icon='/media/icons/duotune/general/gen067.svg'
        fontIcon='bi-person'
      />
      }
      { (hasRole(['CAMS Admin','System Admin'])) &&
      <SidebarMenuItem
        to='/setsco/company-management/companies'
        title="Companies"
        icon='/media/icons/duotune/ecommerce/ecm008.svg'
        fontIcon='bi-company'
      />
      }
      { (hasRole(['CAMS Admin','System Admin'])) &&
      <SidebarMenuItem
          to='/setsco/system-settings/configuration'
          title="Config"
          icon='/media/icons/duotune/general/gen019.svg'
          fontIcon='bi-grid-1x2'
      />
      }
      { (hasRole(['System Admin','DLM Admin'])) &&
      <SidebarMenuItem
        to='/setsco/doclabel-management/dlmtypes'
        title="DLM Types"
        icon='/media/icons/duotune/ecommerce/ecm009.svg'
        fontIcon='bi-grid-1x2'
      />
      }
      { (hasRole(['System Admin','DLM Admin'])) &&
      <SidebarMenuItem
        to='/setsco/doclabel-management/labelsets'
        title="Label Sets"
        icon='/media/icons/duotune/general/gen028.svg'
        fontIcon='bi-grid-1x2'
      />
      }
      { (hasRole(['Super Admin'])) &&
      <SidebarMenuItem
        to='/setsco/prices-settings/prices'
        title="Price Settings"
        icon='/media/icons/duotune/finance/fin010.svg'
        fontIcon='bi-person'
      />
      }
      { (hasRole(['CAMS Admin','System Admin','CAMS Program Manager'])) &&
      <SidebarMenuItem
        to='/setsco/producttype-management/producttypes'
        title="Product Types"
        icon='/media/icons/duotune/abstract/abs029.svg'
        fontIcon='bi-grid-1x2'
      />
      }
      { (hasRole(['System Admin','DLM Admin'])) &&
      <SidebarMenuItem
        to='/setsco/doclabel-management/threshold-list'
        title="Thresholds"
        icon='/media/icons/duotune/graphs/gra001.svg'
        fontIcon='bi-grid-1x2'
      />
      }
      { (hasRole(['User Admin','Super Admin'])) &&
      <SidebarMenuItem
        to='/setsco/user-management/users'
        title="Users"
        icon='/media/icons/duotune/communication/com014.svg'
        fontIcon='bi-person'
      />
      }
    </SidebarMenuItemWithSub>
    }
  </>
  )
}

export {UserSidebarMenu};